import { render } from "./HeroiconsOutlineViewList.vue?vue&type=template&id=ed6e8316"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineViewList.vue"]])

export default __exports__